module.exports = __webpack_public_path__ + "img/Large-Semi-Elliptical-Attachment-R-17.9102b599.png";